
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/ev-test",
      function () {
        return require("private-next-pages/cars/ev-test/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/ev-test"])
      });
    }
  